export default __webpack_public_path__ + "1e4987c5760affc5dd5eee9a9eaf9944.svg";